<div class="content-container">
    <nav class="navbar sticky-top">
        <div class="d-grid gap-2 d-flex navbar-brand">
            <button (click)="this.location.back();" type="button" ngbTooltip="Back" placement="bottom"
                class="btn btn-primary backBtn" aria-label="Back">
                <fa-icon [icon]="faAngleLeft"></fa-icon>
            </button>
            <h2 class="mobileHeading">Sales Tax (Paid)</h2>
        </div>
        <div class="row">
            <div class="col-auto d-flex">
                <select *ngIf="years.length > 0" class="form-select ms-2" style="width: fit-content;"
                    (change)="yearSelected($event);">
                    <option *ngFor="let year of years" [value]="year" [selected]="year == selectedYear">{{year}}
                    </option>
                </select>
                <button type="button" class="btn btn-primary ms-2" (click)="exportReport();">
                    <fa-icon [icon]="faFileDownload"></fa-icon><span class="ms-2 d-none d-md-inline">Export Report</span>
                </button>
            </div>
        </div>
    </nav>
    <div class="row mt-3">
        <div class="card p-0">
            <div class="card-body">
                <h5 class="card-title">Description</h5>
                <p class="card-text m-0">This report can be used to review the paid sales tax for the year. Line Item is
                    included in this report if the payment date falls within selected year.</p>
            </div>
        </div>
    </div>
</div>